import { Component, OnInit, ViewChild, ViewContainerRef, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType } from '@angular/common/http';
import { ModalDialogService, SimpleModalComponent } from 'ngx-modal-dialog';
import { ToastrService } from 'ngx-toastr';
import { domainImage, ActionTable, domainMedia, domain, domainDebug, limitUploadFile } from '../../data/const';
import { Topic } from '../../data/model';
import { CheckRole, Paging, QueryFilter } from '../../data/dt';
import { CommonService } from '../../service/common.service';

@Component({
  selector: 'app-topic',
  templateUrl: './topic.component.html',
  styleUrls: ['./topic.component.scss']
})
export class TopicComponent implements OnInit {
  @ViewChild('TopicModal') public TopicModal: ModalDirective;
  public isActiveMedia: boolean = true;
  public isActiveUpload: boolean = false;
  public isDelay: boolean = false;

  public domain = domain;
  public pagingFile: Paging;
  public countMedia: number;
  public countAllMedia: number;

  public listItemMedia = [];
  public domainMedia = domainMedia;
  public message: string;
  public progress: number;
  public common: CommonService

  public paging: Paging;
  public q: QueryFilter;
  public listTopic = [];
  public listWebsite = [];
  public listLanguage = [];
  public listLanguageTemp = [];
  public listTypeAttributeItem = [];
  public listYear = [];
  public ckeConfig: any;
  public Item: Topic;
  public domainImage = domainImage;
  public httpOptions: any;
  public ItemTranslate: Topic;
  public CheckRole: CheckRole;
  public ActionTable = ActionTable;
  public ActionId: number;
  public CheckAll: boolean;
  public RoleCode: string = localStorage.getItem("roleCode") || '';
  public isNoitify: boolean = false;
  public languageId: number;

  public staticDomain: string;
  public staticDomainMedia: string;
  public domainDebug = domainDebug;
  constructor(
    public http: HttpClient,
    public modalDialogService: ModalDialogService,
    public viewRef: ViewContainerRef,
    public toastr: ToastrService
  ) {
    this.pagingFile = new Paging();
    this.pagingFile.page = 1;
    this.pagingFile.page_size = 24;
    this.pagingFile.query = "1=1";
    this.pagingFile.order_by = "";
    this.pagingFile.item_count = 0;
    this.countMedia = 24;

    this.Item = new Topic();
    this.paging = new Paging();
    this.paging.page = 1;
    this.paging.page_size = 10;
    this.paging.query = "1=1";
    this.paging.order_by = "CreatedAt Desc";
    this.paging.item_count = 0;

    this.q = new QueryFilter();
    this.q.txtSearch = "";
    this.languageId = localStorage.getItem("languageId") != undefined ? parseInt(localStorage.getItem("languageId")) : 1;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + localStorage.getItem("access_token")
      })
    }

    // this.CheckRole = new CheckRole();
    // let code = "QLDT";
    // this.CheckRole.View = this.common.CheckAccessKeyRole(localStorage.getItem("access_key"), code, 0);
    // this.CheckRole.Create = this.common.CheckAccessKeyRole(localStorage.getItem("access_key"), code, 1);
    // this.CheckRole.Update = this.common.CheckAccessKeyRole(localStorage.getItem("access_key"), code, 2);
    // this.CheckRole.Delete = this.common.CheckAccessKeyRole(localStorage.getItem("access_key"), code, 3);
  }

  ngOnInit() {
    this.ckeConfig = {
      allowedContent: false,
      extraPlugins: 'divarea',
      forcePasteAsPlainText: true
    };
    this.GetListTopic();
    this.GetListWebsite();
    this.GetListLanguage();
    this.GetListTypeAttributeItem();
    // this.GetListTypeAttributeItem(1);
    // this.GetListTypeAttributeItem(1008);
    this.GetDomainStatic();
    this.GetListYear();
  }

  GetDomainStatic() {
    this.http.get('api/Config/1', this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.staticDomain = res["data"].Website;
          if (res["data"].ModeSite) {
            this.staticDomainMedia = this.domainDebug + 'uploads';
            this.staticDomain = this.domainDebug;
          } else {
            this.staticDomainMedia = this.staticDomain + 'uploads';
            this.staticDomain = res["data"].Website;
          }
        }
      },
      (err) => {
        console.log("Error: connect to API");
      }
    );
  }

  // Get danh sách topic
  GetListTopic() {
    this.http.get('/api/topic/GetByPage?page=' + this.paging.page + '&page_size=' + this.paging.page_size + '&query=' + this.paging.query + '&order_by=' + this.paging.order_by, this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.listTopic = res["data"];
          this.paging.item_count = res["metadata"];
        }
      },
      (err) => {
        console.log("Error: connect to API");
      }
    );
  }

  GetListYear() {
    this.http.get('/api/DropDown/GetYear').subscribe(
      (res: any) => {
        if (res.meta.error_code === 200) {
          this.listYear = res.data;
        }
      },
      (err) => {
        console.error("Error: connect to API", err);
      }
    );
  }

  // Get danh sách ngôn ngữ
  GetListLanguage() {
    this.http.get('/api/Language/GetByPage?page=1&query=1=1&order_by=', this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.listLanguage = res["data"];
          if (this.listLanguage.length == 1 && (this.Item.TopicId == undefined || (this.Item.TopicId != undefined && this.Item.LanguageId == undefined))) {
            this.Item.LanguageId = this.listLanguage[0].LanguageId;
          }
        }
      },
      (err) => {
        console.log("Error: connect to API");
      }
    );
  }

  //Get danh sách website
  GetListWebsite() {
    this.http.get('/api/Website/GetByPage?page=1&query=1=1&order_by=', this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.listWebsite = res["data"];
        }
      },
      (err) => {
        console.log("Error: connect to API");
      }
    );
  }

  GetListTypeAttributeItem(): void {
    this.http.get('/api/TypeAttributeItem/GetByPage?page=1&query=TypeAttributeId=29&order_by=TypeAttributeItemId Asc', this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.listTypeAttributeItem = res["data"];
          this.updateLabelBasedOnLanguage();
        }
      }, (err) => {
        console.log("Error: connect to API", err);
      });
  }  

  updateLabelBasedOnLanguage(): void {
    if (this.Item.LanguageId === 1008) {
      this.listTypeAttributeItem = this.listTypeAttributeItem.map(item => ({
        ...item,
        displayName: item.EnglishName
      }));
    } else {
      this.listTypeAttributeItem = this.listTypeAttributeItem.map(item => ({
        ...item,
        displayName: item.Name
      }));
    }
  }

  // updateLabelBasedOnLanguage(): void {
  //   this.listTypeAttributeItem = this.listTypeAttributeItem.map(item => {
  //     const displayName = `${item.Name || ''} / ${item.EnglishName || ''}`;
  //     return {
  //       ...item,
  //       displayName: displayName
  //     };
  //   });
  // }

  //Chuyển trang
  PageChanged(event) {
    this.paging.page = event.page;
    this.GetListTopic();
  }

  //Toast cảnh báo
  toastWarning(msg): void {
    this.toastr.warning(msg, 'Cảnh báo');
  }

  //Toast thành công
  toastSuccess(msg): void {
    this.toastr.success(msg, 'Hoàn thành');
  }

  //Toast thành công
  toastError(msg): void {
    this.toastr.error(msg, 'Lỗi');
  }

  //
  QueryChanged() {
    let query = '';
    // Kiểm tra và thêm điều kiện tìm kiếm theo txtSearch cho các trường Name, Code, TopicLeader
    if (this.q.txtSearch != undefined && this.q.txtSearch != '') {
      const searchQuery = 'Name.Contains("' + this.q.txtSearch + '")' +
                          ' or Code.Contains("' + this.q.txtSearch + '")' +
                          ' or TopicLeader.Contains("' + this.q.txtSearch + '")';
  
      if (query != '') {
        query += ' and (' + searchQuery + ')';
      } else {
        query += '(' + searchQuery + ')';
      }
    }
  
    // Thêm điều kiện cho TypeImplement nếu TypeAttributeId có giá trị
    if (this.q["TypeAttributeId"] != undefined) {
      if (query != '') {
        query += ' and TypeImplement=' + this.q["TypeAttributeId"];
      } else {
        query += 'TypeImplement=' + this.q["TypeAttributeId"];
      }
    }

    if (this.q["ImplementYear"] != undefined) {
      if (query != '') {
        query += ' and ImplementYear=' + this.q["ImplementYear"];
      } else {
        query += 'ImplementYear=' + this.q["ImplementYear"];
      }
    }
  
    // Thêm điều kiện cho LanguageId nếu LanguageId có giá trị
    if (this.q.LanguageId != undefined) {
      if (query != '') {
        query += ' and LanguageId=' + this.q.LanguageId;
      } else {
        query += 'LanguageId=' + this.q.LanguageId;
      }
    }
  
    // Nếu không có điều kiện nào, đặt query thành '1=1' (không lọc dữ liệu)
    if (query == '') {
      this.paging.query = '1=1';
    } else {
      this.paging.query = query;
    }
  
    // Gọi phương thức để lấy danh sách theo query đã xây dựng
    this.GetListTopic();
  }
  
  clearSearch(): void {
    this.q.txtSearch = '';
    this.QueryChanged();
  }

  ShowHide(item) {
    item.UserId = parseInt(localStorage.getItem("userId"));
    item.CompanyId = parseInt(localStorage.getItem("companyId"));
    item.WebsiteId = parseInt(localStorage.getItem("websiteId"));
    // Kiểm tra và lấy LanguageId từ object `language` nếu tồn tại
    if (item.language && item.language.LanguageId) {
      item.LanguageId = item.language.LanguageId;  // Lấy LanguageId từ object language
    } else {
      this.toastError("Ngôn ngữ không xác định. Vui lòng kiểm tra lại.");
      return;
    }
  
    console.log("Current LanguageId:", item.LanguageId);

    this.http.put('/api/Topic/' + item.TopicId, item, this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.GetListTopic();
          this.toastSuccess("Cập nhật thành công!");
        }
        else {
          this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
        }
      },
      (err) => {
        this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
      }
    );
  }  

  OpenTopicModal(item, type) {
    // Khởi tạo các thuộc tính của Topic ngay từ đầu
    this.Item = new Topic();
    this.Item.Description = "";
    this.Item.LanguageId = this.languageId;
    this.Item.Position = this.paging.item_count + 1;
    this.Item.TopicId = undefined;
    this.Item.TopicRootId = undefined;
    this.Item.LanguageRootId = undefined;
    this.Item.LanguageRootCode = undefined;
    this.Item.LanguageCode = undefined;
    this.listLanguageTemp = this.listLanguage;
    this.message = undefined;
    this.progress = undefined;

    if (item != undefined) {
      this.Item = JSON.parse(JSON.stringify(item));

      if (type === 1) {
        // Logic cho chỉnh sửa
        // Giữ nguyên các thuộc tính ngôn ngữ hiện có
        this.Item.LanguageId = item.language.LanguageId;
      }

      if (type === 2) {
        if (this.listLanguage.length === item.listLanguage.length + 1) {
          this.toastWarning("Bạn đã thêm đủ ngôn ngữ!");
          return;
        }

        // Khởi tạo lại các giá trị cho việc thêm ngôn ngữ
        this.listLanguageTemp = [];
        this.Item.TopicId = undefined;
        this.Item.TopicRootId = item.TopicId;
        this.Item.LanguageRootId = item.LanguageId;
        this.Item.LanguageRootCode = this.Item["language"]["Code"];
        this.Item.LanguageId = undefined;
        this.Item.LanguageCode = undefined;

        // Kiểm tra và loại bỏ các ngôn ngữ đã có
        for (let i = 0; i < this.listLanguage.length; i++) {
          let check = false;
          if (this.listLanguage[i].LanguageId === this.languageId) {
            check = true;
          }
          if (item.listLanguage.length > 0) {
            for (let j = 0; j < item.listLanguage.length; j++) {
              if (this.listLanguage[i].LanguageId === item.listLanguage[j].lang.LanguageId) {
                check = true;
                break;
              }
            }
          }
          if (!check) {
            this.listLanguageTemp.push(this.listLanguage[i]);
          }
        }

        if (this.listLanguageTemp.length > 0) {
          this.Item.LanguageId = this.listLanguageTemp[0].LanguageId;
          this.Item.LanguageCode = this.listLanguageTemp[0].Code;
        }

        this.GetTranslate(this.Item.TopicRootId);
      }
    }

    // Hiển thị modal cho việc thêm hoặc sửa Topic
    this.TopicModal.show();

    // Tải danh sách mục dropdown với ngôn ngữ đã chọn sau khi mở modal
    this.GetListTypeAttributeItem();
  }

  GetTranslate(id) {
    let sl = this.Item.LanguageRootCode;
    let tl = this.Item.LanguageCode;
    this.ItemTranslate = new Topic();
    this.http.get('/api/translate/' + id + '/' + sl + '/' + tl + '/5', this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.ItemTranslate = res["data"];
          this.Item.TopicId = undefined;
          this.Item.Code = this.ItemTranslate.Code;
          this.Item.Name = this.ItemTranslate.Name;
          this.Item.Description = this.ItemTranslate.Description;
          this.Item.TopicLeader = this.ItemTranslate.TopicLeader;
          this.Item.Member = this.ItemTranslate.Member;
          this.Item.TypeImplement = this.ItemTranslate.TypeImplement;
          this.Item.ExecutionTime = this.ItemTranslate.ExecutionTime;
        }
      },
      (err) => {
        console.log("Error: connect to API");
      }
    );
  }
  
  //Thêm mới danh mục trang
  SaveTopic() {
    if (this.Item.Code == undefined || this.Item.Code === '') {
      this.toastWarning("Chưa nhập mã đề tài!");
      return;
    } else if (!this.Item.Name || this.Item.Name.trim() === '') {
      this.toastWarning("Chưa nhập tên!");
      return;
    } else if (!this.Item.TopicLeader || this.Item.TopicLeader.trim() === '') {
      this.toastWarning("Chưa nhập chủ nhiệm đề tài!");
      return;
    } else if (this.Item.TypeImplement == undefined || this.Item.TypeImplement === 0) {
      this.toastWarning("Chưa chọn cấp thực hiện!");
      return;
    } else if (this.Item.ImplementYear == undefined || this.Item.ImplementYear === 0) {
      this.toastWarning("Chưa chọn năm thực hiện!");
      return;
    } else if (this.Item.Position == undefined || this.Item.Position.toString().trim() === '') {
      this.toastWarning("Chưa nhập vị trí!");
      return;
    }

    this.Item.UserId = parseInt(localStorage.getItem("userId"));
    this.Item.CompanyId = parseInt(localStorage.getItem("companyId"));
    this.Item.WebsiteId = parseInt(localStorage.getItem("websiteId"));

    // if (!this.Item.LanguageId) {
    //   this.Item.LanguageId = parseInt(localStorage.getItem("languageId"));
    // }

    if (this.Item.TopicId == undefined) {
      this.http.post('/api/Topic', this.Item, this.httpOptions).subscribe(
        (res) => {
          if (res["meta"]["error_code"] == 200) {
            this.GetListTopic();
            this.TopicModal.hide();
            this.toastSuccess("Thêm mới thành công!");
          }
          else {
            this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
          }
        },
        (err) => {
          this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
        }
      );
    }
    else {
      this.http.put('/api/Topic/' + this.Item.TopicId, this.Item, this.httpOptions).subscribe(
        (res) => {
          if (res["meta"]["error_code"] == 200) {
            this.GetListTopic();
            this.TopicModal.hide();
            this.toastSuccess("Cập nhật thành công!");
          }
          else {
            this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
          }
        },
        (err) => {
          this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
        }
      );
    }
  }

  //Popup xác nhận xóa
  ShowConfirmDelete(Id) {
    this.modalDialogService.openDialog(this.viewRef, {
      title: 'Xác nhận',
      childComponent: SimpleModalComponent,
      data: {
        text: "Bạn có chắc chắn muốn xóa bản ghi này?"
      },
      actionButtons: [
        {
          text: 'Đồng ý',
          buttonClass: 'btn btn-success',
          onAction: () => {
            this.Delete(Id);
          }
        },
        {
          text: 'Đóng',
          buttonClass: 'btn btn-danger',

        }
      ],
    });
  }

  Delete(Id) {
    this.http.delete('/api/Topic/' + Id, this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.viewRef.clear();
          this.toastSuccess("Xóa thành công!");
          this.GetListTopic();
        }
        else {
          this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
        }
      },
      (err) => {
        this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
      }
    );
  }

  SortTable(str) {
    let First = "";
    let Last = "";
    if (this.paging.order_by != "") {
      First = this.paging.order_by.split(" ")[0];
      Last = this.paging.order_by.split(" ")[1];
    }

    if (First != str) {
      this.paging.order_by = str + " Desc";
    }
    else {
      Last = Last == "Asc" ? "Desc" : "Asc";
      this.paging.order_by = str + " " + Last;
    }

    this.GetListTopic();
  }

  GetClassSortTable(str) {
    if (this.paging.order_by != (str + " Desc") && this.paging.order_by != (str + " Asc")) {
      return "sorting";
    }
    else {
      if (this.paging.order_by == (str + " Desc")) return "sorting_desc";
      else return "sorting_asc";
    }
  }

  CheckActionTable(TopicId) {
    if (TopicId == undefined) {
      let CheckAll = this.CheckAll;
      this.listTopic.forEach(item => {
        item.Action = CheckAll;
      });
    }
    else {
      let CheckAll = true;
      for (let i = 0; i < this.listTopic.length; i++) {
        if (!this.listTopic[i].Action) {
          CheckAll = false;
          break;
        }
      }

      this.CheckAll = CheckAll == true ? true : false;
    }
  }

  ActionTableFunc() {
    switch (this.ActionId) {
      case 1:
        let data = [];
        this.listTopic.forEach(item => {
          if (item.Action == true) {
            data.push(item.TopicId);
          }
        });
        if (data.length == 0) {
          this.toastWarning("Chưa chọn bản ghi cần xóa!");
        }
        else {
          this.modalDialogService.openDialog(this.viewRef, {
            title: 'Xác nhận',
            childComponent: SimpleModalComponent,
            data: {
              text: "Bạn có chắc chắn muốn xóa các bản ghi đã chọn?"
            },
            actionButtons: [
              {
                text: 'Đồng ý',
                buttonClass: 'btn btn-success',
                onAction: () => {
                  this.http.put('/api/topic/deletes', data, this.httpOptions).subscribe(
                    (res) => {
                      if (res["meta"]["error_code"] == 200) {
                        this.toastSuccess("Xóa thành công!");
                        this.GetListTopic();
                        this.ActionId = undefined;
                      }
                      else {
                        this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
                      }
                    },
                    (err) => {
                      this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
                    }
                  );
                  this.viewRef.clear();
                }
              },
              {
                text: 'Đóng',
                buttonClass: 'btn btn-danger',

              }
            ],
          });
        }
        break;
      default:
        break;
    }
  }

  closeNoityfy() {
    this.isNoitify = true;
  }
}
